import { PlanName, PlanRenewalType } from '@tribeplatform/gql-client/types'
import { useBaskets, usePurchase } from '@tribeplatform/react-sdk/hooks'
import { Button } from '@tribeplatform/react-ui-kit/Button'
import { Card } from '@tribeplatform/react-ui-kit/Card'
import { Link } from '@tribeplatform/react-ui-kit/Link'
import { toast } from '@tribeplatform/react-ui-kit/Toast'

export const PurchaseCard = ({
  planName,
  renewalType,
  seats,
}: {
  planName: PlanName
  renewalType: PlanRenewalType
  seats: number
}) => {
  const { data: baskets } = useBaskets({
    variables: {
      input: {
        name: planName,
        seats,
      },
    },
  })
  const { mutateAsync: purchase, isLoading } = usePurchase()

  const basket = baskets?.find(basket => basket?.renewalType === renewalType)

  const handlePurchase = async () => {
    try {
      await purchase({
        input: {
          planName,
          renewalType,
          seats,
        },
      })
      toast({
        title: 'Purchase successful',
        status: 'success',
      })
    } catch (e) {
      toast({
        title: 'Unable to purchase',
        description: e?.response?.errors
          ?.map(error => error?.message)
          .join('\n'),
        status: 'error',
      })
    }
  }

  return (
    <Card>
      <Card.Header title="Billing summary" />
      <Card.Content>
        <div className="flex flex-col space-y-5">
          <div className="flex flex-col space-y-5">
            {basket?.items?.map(item => (
              <div className="flex justify-between" key={item?.title}>
                <div>{item?.title}</div>
                <div>{item?.value?.formattedValue}</div>
              </div>
            ))}
            <div className="flex justify-between">
              <div>Total</div>
              <div>{basket?.total?.formattedValue}</div>
            </div>
          </div>
          <div>
            <Button
              variant="primary"
              fullWidth
              onClick={handlePurchase}
              loading={isLoading}
            >
              Confirm
            </Button>
          </div>
          <div>
            By confirming, you agree to the plan’s{' '}
            <Link href="https://tribe.so/terms-of-service" external>
              Terms & Conditions
            </Link>{' '}
            and{' '}
            <Link href="https://tribe.so/privacy-policy" external>
              Privacy Policy
            </Link>
            . You understand that your subscription starts today.
          </div>
        </div>
      </Card.Content>
    </Card>
  )
}
